import React from 'react';
import { FileText } from 'lucide-react';

const PlaceholderView = ({ title }) => {
  return (
    <div className="bg-white p-12 rounded-lg shadow-md text-center">
      <FileText className="w-16 h-16 text-gray-300 mx-auto mb-4" />
      <h3 className="text-lg font-medium text-gray-500 mb-2">功能開發中</h3>
      <p className="text-gray-400">{title || '此功能'}正在開發中，敬請期待</p>
    </div>
  );
};

export default PlaceholderView; 